import React from 'react';
import { Box, Text, Flex } from '@applatform/design-system';
import { ReactComponent as Logo } from 'icons/zai-logo.svg';
import Banner from './Banner/Banner';

interface PublicLayoutProps {
  children: React.ReactNode;
}

function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <Flex
      css={{
        minHeight: '100vh',
        flexDirection: 'column',
        '@md': { flexDirection: 'row' },
      }}
    >
      <Banner />
      <Box
        as="main"
        css={{
          flexGrow: 1,
          flexBasis: '60%',
          textAlign: 'center',
          px: '$8',
        }}
      >
        <Box
          css={{
            display: 'none',
            mt: '$20',
            mb: '$8',
            '@md': {
              display: 'block',
              mt: '$16',
              mb: '$12',
            },
          }}
        >
          <Logo width="128" height="50" aria-label="Zai" />
        </Box>
        <Box
          css={{
            maxWidth: '380px',
            mx: 'auto',
            mb: '$24',
            '@md': { mb: '$32' },
          }}
        >
          {children}
        </Box>
        <Text
          size="sm"
          css={{
            mb: '$20',
            color: '$secondaryGrey',
            textAlign: 'center',
          }}
        >
          &copy; {new Date().getFullYear()} Zai
        </Text>
      </Box>
    </Flex>
  );
}

export default PublicLayout;
